/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-unused-vars */
import React from "react";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";

const captionStyles = {
  position: "absolute",
  bottom: 50,
  align: "center",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "rgba(97, 97, 97, 0.6)",
  display: "flex",
  border: "2px solid #E0E0E0",
  boxShadow: "0px 8px 10px rgba(0, 0, 0, 0.4)",
  borderRadius: "6px",
};

function VideoCaption() {
  const ttsState = useSelector((state) => state.ttsState.tts);
  const ovState = useSelector((state) => state.ovState.ov);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {ttsState != null && ttsState.length > 0 && ovState === "SPEAKING" && (
        <div style={captionStyles}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "30rem",
            }}
          >
            <Typography
              sx={{ verticalAlign: "middle", display: "inline-flex" }}
            >
              <VolumeUpOutlinedIcon sx={{ marginRight: 1 }} />
              {ttsState}
            </Typography>
          </div>
        </div>
      )}
    </>
  );
}

export default VideoCaption;
